import webApi from "./api";
import store from "@/store";

export class TopPageService {
  searchRedbookRego(data) {
    return webApi.post("car-detail/rego-redbook-api", data);
  }
  searchAutograbRego(data) {
    return webApi.post("car-detail/rego-autograb-api", data);
  }
  getSystemConfig() {
    return webApi.get("system-configurations?locid=2");
  }
  async searchRego(data) {
    let vehicleDataSource = store.getters.systemConfigurations.vehicleDataSource;

    if (!vehicleDataSource) {
      try {
        const systemConfigResult = await this.getSystemConfig();
        vehicleDataSource =
          systemConfigResult.status === 200 &&
          systemConfigResult.data.vehicleDataSource
            ? systemConfigResult.data.vehicleDataSource
            : null;
      } catch (error) {
        console.error('Failed to get system configurations:', error);
        return this.searchRedbookRego(data);
      }
    }

    // Check if activeSource is RB, then use searchRedbookRego
    if (vehicleDataSource?.activeSource === "RB") {
      return this.searchRedbookRego(data);
    }
    // Check if activeSource is AG, then use searchAutograbRego
    else if (vehicleDataSource?.activeSource === "AG") {
      return this.searchAutograbRego({
        regoNumber: data.regoNumber,
        locid: data.locid,
      });
    }
    // Default fallback to redbook API
    else {
      return this.searchRedbookRego(data);
    }
  }
}

const topPageService = new TopPageService();

export default topPageService;
